export default class Constants {
    static BOARD_PAGE_NUMBER = 10;
    static LATEST_SEARCH_SUBEJCTS = 'latest-search-subjects';
    static SETTINGS_OMR = 'settingsOmr';
    static SNACKBAR_HIDE = 'snackbarHide';
    static IS_USED_TEST_PAPER_LIBRARY = false;
    static APP_VERSION = 'appVersion';
}